import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Container, Table, Button } from "react-bootstrap";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import { apiGetPublications, apiUpdatePublications } from "../../api/ApiPublication";
import { MdOutlineEdit, MdDeleteOutline, MdAddCircleOutline, MdDone } from "react-icons/md";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import ModalCreateUpdate from "../../components/admin/publication/ModalCreateUpdate";
import ComponentLoader from "../../components/layout/ComponentLoader";
import ModalDelete from "../../components/admin/publication/ModalDelete";

const PageAdminPublication = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [showCreateUpdate, setShowCreateUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const [prochainIndice, setProchainIndice] = useState(0);
  const [order, setOrder] = useState(false);
  const [loader, setLoader] = useState(false);
  const [idPublication, setIdPublication] = useState("");
  const [publications, setPublications] = useState([]);

  const handleShowCreateUpdate = (id) => {
    setIdPublication(id);
    setShowCreateUpdate(true);
  };
  const handleCloseCreateUpdate = () => {
    setIdPublication(null);
    setShowCreateUpdate(false);
  };

  const handleShowDelete = (id) => {
    setIdPublication(id);
    setShowDelete(true);
  };
  const handleCloseDelete = () => {
    setIdPublication(null);
    setShowDelete(false);
  };

  const changeOrdre = (index, sens) => {
    setOrder(true);
    const publicationCopy = [...publications];
    const elementSauvegarde = publicationCopy[index];
    if (sens === "haut") {
      if (index !== 0) {
        publicationCopy[index] = publicationCopy[index - 1];
        publicationCopy[index - 1] = elementSauvegarde;
      }
    }
    if (sens === "bas") {
      if (index !== publications.length - 1) {
        publicationCopy[index] = publicationCopy[index + 1];
        publicationCopy[index + 1] = elementSauvegarde;
      }
    }
    setPublications(publicationCopy);
  };

  const SubmitData = async () => {
    setOrder(false);
    setLoader(true);
    const publicationCopy = [...publications].reverse();
    publicationCopy.forEach((publication, index) => {
      publication.ordre = index;
    });
    console.log(publicationCopy);
    await apiUpdatePublications(publicationCopy);
    setPublications(publicationCopy.reverse());
    recupPublications();
    setLoader(false);
  };

  const recupPublications = async () => {
    const res = await apiGetPublications(ReduxInstance._id, "sort[ordre]=-1");
    if (res.data[0]) {
      setProchainIndice(res.data[0].ordre + 1);
      setPublications(res.data);
    }
  };

  useEffect(() => {
    recupPublications();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminPublications.titre")} />
        <span role="button" onClick={() => handleShowCreateUpdate("")}>
          <MdAddCircleOutline size="1.5em" />
          {t("admin.PageAdminPublications.ajouter")}
        </span>
        <Table striped bordered hover className="stickyTable mt-2">
          <thead>
            <tr>
              <th>{t("admin.PageAdminPublications.titreColonne1")}</th>
              <th>{t("admin.PageAdminPublications.titreColonne2")}</th>
              <th className="text-center">{t("admin.PageAdminPublications.titreColonne3")}</th>
              <th className="text-center">{t("admin.PageAdminPublications.titreColonne4")}</th>
              <th className="text-center">{t("admin.PageAdminPublications.titreColonne5")}</th>
            </tr>
          </thead>
          <tbody>
            {publications.map((publication, index) => (
              <tr key={index}>
                <td>
                  <TiArrowSortedUp
                    size="1.5em"
                    role="button"
                    onClick={(e) => changeOrdre(index, "haut")}
                  />
                  <TiArrowSortedDown
                    size="1.5em"
                    role="button"
                    onClick={(e) => changeOrdre(index, "bas")}
                  />
                  {publication.nom}
                </td>
                <td>
                  <a href={publication.URL} target="_blank" rel="noreferrer">
                    {publication.URL}
                  </a>
                </td>
                <td className="text-center">{publication.publie && <MdDone size="1.5em" />}</td>
                <td className="text-center">
                  <MdOutlineEdit
                    size="1.5em"
                    role="button"
                    onClick={() => handleShowCreateUpdate(publication._id, publication.nom)}
                  />
                </td>
                <td className="text-center">
                  <MdDeleteOutline
                    size="1.5em"
                    role="button"
                    onClick={() => handleShowDelete(publication._id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {order && (
          <div className="text-end mb-5">
            {loader && <ComponentLoader />}
            <Button variant="success" type="Submit" onClick={(e) => SubmitData()}>
              {t("commun.form.button.enregistrerOrdre")}
            </Button>
          </div>
        )}
        <ModalCreateUpdate
          show={showCreateUpdate}
          id={idPublication}
          handleClose={handleCloseCreateUpdate}
          handleRecupDatas={recupPublications}
          prochainIndice={prochainIndice}
        />
        <ModalDelete
          show={showDelete}
          id={idPublication}
          handleClose={handleCloseDelete}
          handleRecupDatas={recupPublications}
        />
      </Container>
    </>
  );
};

export default PageAdminPublication;
